export enum AppRoutes {
  //Root
  home = '/',
  aboutUs = '/about-us',
  socialHome = 'https://www.wecheck.ai',
  useCases = '/use-cases',
  blog = '/blog',

  //Login
  forgotPasswordCheckYourInbox = '/login/forgot-pasword-check-your-inbox',
  login = '/login/login-form',
  forgotPassword = '/login/forgot-password',
  createPassword = '/login/create-password',

  //SSO
  authSuccess = '/auth/success',
  authError = '/auth/error',

  //SignUp
  registerStart = '/sign-up/sign-up-start',
  registerEmailVerification = '/sign-up/email-verification',
  registerFirstStep = '/sign-up/first-step',
  registerSecondStep = '/sign-up/second-step',
  registerFinalStep = '/sign-up/final-step',
  inviteFirstStep = '/sign-up/invite-first-step',
  inviteSecondStep = '/sign-up/invite-second-step',
  invitationExpired = '/sign-up/invitation-expired',

  //Refresh Report
  newFollowUpReport = '/dashboard/new-follow-up',
  newFollowUpReportUseCase = '/dashboard/new-follow-up/use-case',
  newFollowUpReportConsent = '/dashboard/new-follow-up/consent',
  newFollowUpReportLegalDisclaimer = '/dashboard/new-follow-up/legal-disclaimer',

  //Dashboard
  feedbackScreen = '/dashboard/feedback-screen',
  dashboard = '/dashboard/home',
  support = '/dashboard/support',
  billing = '/dashboard/billing',
  getCredits = '/dashboard/get-credits',
  feedbackPayment = '/dashboard/feedback-payment',
  historyPlan = '/dashboard/history-plan',
  reports = '/dashboard/reports',
  enterprise = '/dashboard/enterprise',
  teamSelection = '/dashboard/team-selection',
  roleGuide = '/dashboard/role-guide',
  yourReports = '/dashboard/your-reports',
  faceMatchResults = '/dashboard/face-match-results',
  settings = '/dashboard/settings',
  settingsAccount = '/dashboard/settings/account',
  settingsSecurity = '/dashboard/settings/security',
  settingsCompany = '/dashboard/settings/company',
  settingsReports = '/dashboard/settings/reports',
  settingsApiKeys = '/dashboard/settings/api-keys',
  faceSearch = '/dashboard/face-search',
  digitalReport = '/dashboard/digital-report',
  postList = '/dashboard/post-list',
  socialMediaProfile = '/dashboard/social-media-profile',
  workspaceCreation = '/dashboard/work-space-creation',
  workspaceSettings = '/dashboard/work-space-settings',
  workspaceCreationSecondStep = '/dashboard/work-space-creation-second-step',
  workspaceCreationThirdStep = '/dashboard/work-space-creation-third-step',
  reportInProgress = '/dashboard/report-in-progress',
  batchSearchInProgress = '/dashboard/batch-search-in-progress',
  generatingReport = '/dashboard/generating-report',
  createTeamFirstStep = '/dashboard/create-team-first-step',
  createTeamSecondStep = '/dashboard/create-team-second-step',
  batchSearch = '/dashboard/batch-search',

  runReportStartSearch = '/dashboard/run-report/start-search',
  runReportSearchForm = '/dashboard/run-report/search-form',
  runReportSearchResults = '/dashboard/run-report/search-results',
  runReportConfirmSubjectDetails = '/dashboard/run-report/confirm-subject-details',
  runReportRefineSearch = '/dashboard/run-report/refine-search',
  runReportSubjectForm = '/dashboard/run-report/subject-form',
  runReportCompanyForm = '/dashboard/run-report/company-form',
  runReportAddExtraDetails = '/dashboard/run-report/add-extra-details',
  runReportBehaviorFlags = '/dashboard/run-report/behavior-flags',
  runReportSubmit = '/dashboard/run-report/submit',
  runReportConsentRequired = '/dashboard/run-report/consent-required',
  runReportSearchStarted = '/dashboard/run-report/search-started',
}
